<template>
  <div :style="{ top: $route.name == 'store' ? '80px' : '20px' }" class="position-sticky">
    <div class="bg-white">
      <div v-if="giftCartItems.length > 0" class="cart-items-wrapper">
        <div class="container">
          <template v-for="(item, index) in giftCartItems">
            <cart-item :cart-item="item" :key="index" />
          </template>
        </div>
      </div>
      <hr v-if="giftCartItems.length > 0" />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">
              Subtotal
              <small class="fw-600">({{ cartLength }} items)</small>
            </div>
            <div class="cart-subtotal-cost">{{ giftCartValue | formatMoney }}</div>
          </div>
        </div>
        <div v-if="giftIsDelivery && deliveryFee" class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">Delivery</div>
            <div class="cart-subtotal-cost">{{ deliveryFee | formatMoney }}</div>
          </div>
        </div>
        <div v-show="false" class="row">
          <div class="col-sm-12 cart-coupon">
            Add Coupon or Gift Card number
            <div class="coupon-form">
              <div class="coupon-input">
                <input type="text" @keydown.enter.prevent />
              </div>
              <div class="coupon-apply">
                <button type="button" class="btn btn-primary btn-md btn-block">Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="total">Total</div>
            <div class="cost">{{ totalPrice | formatMoney }}</div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="orderMode"
              :disabled="orderDisbaled"
              type="submit"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
            >
              Place Order
              <span v-show="proccessing">
                <i class="spin ml-4" />
              </span>
            </button>
            <router-link
              v-else
              :to="{ name: 'giftcardCheckout', params: {storeid: $route.params.storeid, storename: $route.params.storename } }"
              :class="{
                disabled: giftCartItems.length === 0 ? 'disabled' : ''
              }"
              class="btn btn-primary btn-lg btn-block shadow mb-2"
            >{{ "Checkout" }}</router-link>
            <div
              v-show="!exceedMinPurchase"
              class="color-red pt-1 text-center"
            >Minimum purchase is {{ minPurchase | formatMoney }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >Continue Ordering</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import CartItem from "./GiftCartItem";
import { getStore } from "../../../api/services/storeService.js";
import * as moment from "moment";
export default {
  name: "ShoppingCart",
  components: {
    CartItem
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      store: {},

      timerId: null,
      deliveryFee: 0,
      minPurchase: 0
    };
  },
  computed: {
    ...mapGetters(["giftCartValue", "giftCartItems", "giftIsDelivery"]),
    cartLength() {
      let sum = 0;
      this.giftCartItems.forEach(element => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    totalPrice() {
      return this.giftCartValue + (this.giftIsDelivery ? this.deliveryFee : 0);
    },
    exceedMinPurchase() {
      return this.totalPrice >= this.minPurchase;
    },
    refreshTime() {
      return moment()
        .set({ hour: 10, minute: 0, second: 0 })
        .utc();
    },
    now() {
      return moment.utc();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.giftCartItems.length === 0
      );
    }
  },
  watch: {
    store() {
      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...mapMutations(["REMOVE_GIFTCART_ITEM", "setDeliveryFee"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    continueOrder() {
      this.$router.push({
        name: "giftstore",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime)) {
        this.giftCartItems.forEach(element => {
          let createdTime = moment(element.created).utc();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_GIFTCART_ITEM({ item: element });
          }
        });
      }
    },
    computeRules() {
      //delivery fee
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            this.totalPrice > rule.PriceRangeMinimum &&
            this.totalPrice < rule.PriceRangeMaximum
          ) {
            this.deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }
      //this.setDeliveryFee(this.deliveryFee);
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[
            this.orderType
          ].MinimumTotalPrice;
        }
      }
    }
  }
};
</script>
